import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punemumbaicarhire() {



  const cardData =
  {
    keyword: 'Pune Mumbai Car Hire',
    heading: 'Sai Trupti Cabs: Pune Mumbai Car Hire',
    headingDescription: 'Sai Trupti Cabs provides premium Pune Mumbai Car Hire services, ensuring a smooth, safe, and luxurious travel experience for every passenger. Whether you need a car for business meetings, family trips, or airport transfers, our fleet of well-maintained Sedans, SUVs, and Luxury vehicles caters to every travel need. Each car is equipped with modern amenities, air-conditioning, and clean interiors for maximum comfort. Our trained and background-verified drivers ensure punctual pickups, courteous service, and safe driving throughout the journey. With flexible booking options, transparent pricing, and 24×7 customer support, Sai Trupti Cabs makes Pune Mumbai Car Hire simple, reliable, and enjoyable. Experience stress-free travel with Sai Trupti Cabs — your trusted partner for intercity rides between Pune and Mumbai.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Pune Mumbai Car Hire",
    "description": "Pune Mumbai Car Hire offers a seamless and reliable car hire experience for travelers commuting between Pune and Mumbai. Designed to meet the needs of individuals, families, and corporate clients, this service provides a wide range of vehicles including sedans, SUVs, and luxury cars. Every car is maintained in top condition and driven by experienced chauffeurs who ensure a safe and comfortable journey. The service emphasizes punctuality, transparent pricing, and flexibility, allowing travelers to plan business trips, family vacations, or airport transfers with complete peace of mind. Whether you need a one-way drop, round trip, or full-day hire, Pune Mumbai Car Hire ensures you enjoy a smooth and stress-free ride every time."
  },
  {
    "name": "Pune Mumbai Car Rental",
    "description": "Pune Mumbai Car Rental provides an extensive selection of vehicles to suit diverse travel preferences for intercity journeys. Customers can choose from economy hatchbacks, comfortable sedans, spacious MUVs, and luxury cars, each equipped with modern amenities to enhance comfort and safety. Whether traveling for business, leisure, or weekend getaways, this service ensures prompt pickups, professional chauffeurs, and competitive rates. Flexible rental packages allow you to hire vehicles for one-way trips, round trips, or multiple days. With easy booking options and 24/7 customer support, Pune Mumbai Car Rental makes long-distance travel between the two cities effortless, reliable, and affordable."
  },
  {
    "name": "Pune Mumbai Taxi Hire",
    "description": "Pune Mumbai Taxi Hire delivers dependable and efficient taxi services designed for hassle-free travel between Pune and Mumbai. Each taxi is driven by a courteous and trained driver familiar with both city routes and highways, ensuring timely arrivals and maximum comfort. The fleet includes AC and non-AC vehicles, catering to all budget ranges and group sizes. Ideal for corporate transfers, family trips, and airport commutes, this service emphasizes safety, comfort, and reliability. With GPS-enabled cars, flexible scheduling, and transparent billing, Pune Mumbai Taxi Hire guarantees a smooth and stress-free intercity travel experience for every passenger."
  },
  {
    "name": "Pune Mumbai Innova Hire",
    "description": "Pune Mumbai Innova Hire provides premium Toyota Innovas that are perfect for group travel, family outings, and corporate transfers between Pune and Mumbai. These vehicles offer spacious interiors, plush seating, and powerful air conditioning to ensure a comfortable long-distance journey. Ideal for travelers who prioritize comfort and reliability, the service includes professional chauffeurs with excellent route knowledge. Each vehicle undergoes strict maintenance and safety checks before every trip. With flexible booking options, transparent pricing, and on-time pickups, Pune Mumbai Innova Hire stands as the preferred choice for those seeking a premium yet practical travel solution."
  },
  {
    "name": "Pune Mumbai Ertiga Hire",
    "description": "Pune Mumbai Ertiga Hire features comfortable and efficient Maruti Ertigas tailored for small groups and families. These multi-utility vehicles offer excellent mileage, ample luggage space, and ergonomic seating for long journeys. Whether it’s an airport transfer, business trip, or weekend travel, passengers enjoy smooth rides with courteous chauffeurs who prioritize safety and punctuality. The service combines affordability with superior comfort, making it one of the most cost-effective ways to travel between Pune and Mumbai. With online booking options and 24/7 customer support, Pune Mumbai Ertiga Hire ensures every journey is convenient, pleasant, and reliable."
  },
  {
    "name": "Pune Mumbai Sedan Hire",
    "description": "Pune Mumbai Sedan Hire caters to travelers looking for a refined and smooth travel experience. Offering mid-sized sedans such as Honda City, Hyundai Verna, and Toyota Etios, this service guarantees comfort, safety, and style. Sedans are ideal for corporate clients, couples, and small families seeking privacy and sophistication on their trip. Each vehicle is equipped with air conditioning, comfortable seating, and a clean interior maintained to professional standards. The courteous chauffeurs ensure timely departures, smooth navigation, and pleasant service. Pune Mumbai Sedan Hire blends affordability and elegance, making intercity travel more enjoyable and stress-free."
  },
  {
    "name": "Pune Mumbai AC Car Hire",
    "description": "Pune Mumbai AC Car Hire provides air-conditioned vehicles to ensure a comfortable and refreshing journey across the Pune-Mumbai route. This service is ideal for travelers seeking relief from the city’s heat while enjoying a smooth and quiet ride. The fleet includes compact cars, sedans, and SUVs fitted with efficient climate control systems and ergonomic seating. Passengers benefit from professional drivers, timely service, and flexible booking options. Whether you’re traveling for business, a family event, or an airport drop, Pune Mumbai AC Car Hire delivers a relaxing and reliable experience from start to finish."
  },
  {
    "name": "Pune Mumbai Luxury Car Hire",
    "description": "Pune Mumbai Luxury Car Hire is tailored for travelers who demand sophistication, comfort, and style. Featuring high-end brands like Mercedes, BMW, and Audi, this service caters to executives, VIPs, and special occasions. Each luxury car comes equipped with plush interiors, entertainment systems, and professional chauffeurs trained in premium hospitality. Perfect for corporate transfers, weddings, and high-profile events, this service offers unmatched comfort, privacy, and elegance. Pune Mumbai Luxury Car Hire redefines intercity travel by combining world-class vehicles with flawless service, ensuring every ride feels like a first-class experience."
  },
  {
    "name": "Pune Mumbai Chauffeur Service",
    "description": "Pune Mumbai Chauffeur Service provides professional, well-trained drivers to deliver a premium travel experience between Pune and Mumbai. Each chauffeur is background-verified, courteous, and knowledgeable about all routes, ensuring punctual and safe travel. Customers can choose from sedans, SUVs, or luxury cars based on their preferences. The service is ideal for business professionals, foreign delegates, and families who value comfort and safety. With 24/7 availability, on-demand bookings, and top-notch service standards, Pune Mumbai Chauffeur Service ensures a smooth, convenient, and elegant travel experience every time."
  },
  {
    "name": "Affordable Pune Mumbai Car Rental",
    "description": "Affordable Pune Mumbai Car Rental focuses on offering high-quality car rental services at economical rates. Perfect for budget-conscious travelers, this service combines affordability with comfort and safety. Customers can choose from hatchbacks, sedans, and multi-utility vehicles maintained in excellent condition. Professional chauffeurs ensure punctual pickups, courteous interactions, and safe driving practices. Whether you need a short business trip or a family journey, Affordable Pune Mumbai Car Rental guarantees value for money without sacrificing reliability or service quality."
  },
  {
    "name": "Pune Mumbai Outstation Hire",
    "description": "Pune Mumbai Outstation Hire specializes in intercity travel for customers looking to hire vehicles for extended trips or one-way travel. The service includes a range of vehicle types suitable for individual or group travel. Drivers are trained to handle long-distance routes efficiently while maintaining safety and comfort. Whether you’re traveling for leisure, business, or family visits, Pune Mumbai Outstation Hire ensures hassle-free journeys with flexible rental plans, transparent billing, and dedicated customer support throughout your trip."
  },
  {
    "name": "Pune Mumbai Airport Transfer Hire",
    "description": "Pune Mumbai Airport Transfer Hire provides reliable and on-time cab services for passengers traveling to or from Mumbai Airport. This service ensures smooth connectivity for early morning or late-night flights, with drivers who monitor flight schedules to guarantee punctual pickups. The vehicles are comfortable, clean, and spacious enough for passengers and luggage. Whether for domestic or international terminals, Pune Mumbai Airport Transfer Hire delivers a seamless travel experience with professional service and peace of mind for every traveler."
  },
  {
    "name": "Pune Mumbai Car Booking Online",
    "description": "Pune Mumbai Car Booking Online simplifies intercity travel planning by allowing customers to book vehicles digitally with instant confirmation. Through the online platform, passengers can compare prices, choose their preferred car type, and make secure payments with ease. Real-time updates, driver tracking, and 24/7 support ensure complete transparency and reliability. Pune Mumbai Car Booking Online saves time while offering personalized options for one-way, round-trip, and airport transfers, ensuring an effortless booking experience from start to finish."
  },
  {
    "name": "Pune Mumbai Vehicle Hire",
    "description": "Pune Mumbai Vehicle Hire provides versatile travel options for all kinds of travelers, offering cars, vans, and SUVs suited for both short and long-distance journeys. The vehicles are well-maintained, sanitized, and equipped with modern amenities to ensure passenger comfort. Whether you need transport for a business meeting, vacation, or event, this service offers flexible rental durations and competitive pricing. Professional chauffeurs ensure safe, efficient, and pleasant travel experiences, making Pune Mumbai Vehicle Hire a dependable choice for intercity commuters."
  },
  {
    "name": "Pune Mumbai Taxi near Me",
    "description": "Pune Mumbai Taxi near Me ensures quick and easy access to taxis available in your locality for intercity trips. The service prioritizes convenience by connecting travelers with nearby drivers who can provide immediate or scheduled pickups. With reliable vehicles, experienced drivers, and flexible booking options, passengers enjoy stress-free travel between Pune and Mumbai. Ideal for last-minute plans or planned journeys, Pune Mumbai Taxi near Me delivers comfort, safety, and affordability for every type of traveler."
  }
],
"tableData": [
  ["Pune Mumbai Car Hire", "Pune Mumbai Car Rental"],
  ["Pune Mumbai Taxi Hire", "Pune Mumbai Innova Hire"],
  ["Pune Mumbai Ertiga Hire", "Pune Mumbai Sedan Hire"],
  ["Pune Mumbai AC Car Hire", "Pune Mumbai Luxury Car Hire"],
  ["Pune Mumbai Chauffeur Service", "Affordable Pune Mumbai Car Rental"],
  ["Pune Mumbai Outstation Hire", "Pune Mumbai Airport Transfer Hire"],
  ["Pune Mumbai Car Booking Online", "Pune Mumbai Vehicle Hire"],
  ["Pune Mumbai Taxi near Me", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune Mumbai Car Hire Service",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable car hire services between Pune and Mumbai, perfect for business trips, airport transfers, and leisure travel."
  },
  {
    "WhyChooseheading": "Wide Range of Cars",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and luxury cars to suit your group size, luggage, and travel preferences."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers ensure a safe, smooth, and punctual journey on the Pune–Mumbai route."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Benefit from clear and competitive pricing with no hidden charges, making your car hire cost-effective and worry-free."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off",
    "WhyChoosedescription": "We offer convenient pickups and drop-offs across Pune and Mumbai, including airports, railway stations, and city locations."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "All cars are regularly serviced, sanitized, and maintained to provide a comfortable long-distance travel experience."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support",
    "WhyChoosedescription": "Our dedicated team is available around the clock to assist with bookings, travel planning, and customer queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Mumbai car hire easily via call, WhatsApp, or our website, with instant confirmation and prompt vehicle dispatch."
  }
]


















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune Mumbai car hire services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune Mumbai car hire services for one way, round trips, and business travel.',
  },
  {
    question: 'How can I hire a car from Pune to Mumbai with Sai Trupti Cabs?',
    answer: 'You can easily hire a car from Pune to Mumbai through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cars are available for hire from Pune to Mumbai?',
    answer: 'We offer a wide range of cars including hatchbacks, sedans, SUVs, luxury cars, and tempo travellers to suit your travel needs and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Mumbai car hire services?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving on the Pune–Mumbai Expressway, ensuring a safe and comfortable ride.',
  },
  {
    question: 'Can I hire a car for corporate or personal travel between Pune and Mumbai?',
    answer: 'Certainly. Our car hire services cater to both corporate clients and individual travelers for meetings, events, or leisure trips.',
  },
  {
    question: 'Is the Pune Mumbai car hire service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 car hire services between Pune and Mumbai for your convenience and travel flexibility.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune Mumbai car hire?',
    answer: 'All our vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety protocols to ensure a secure journey.',
  },
  {
    question: 'What payment methods are accepted for Pune Mumbai car hire?',
    answer: 'We accept payments through UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'Is customer support available during the Pune Mumbai car hire journey?',
    answer: 'Yes, our dedicated 24×7 customer support team is always available to assist you throughout your Pune to Mumbai travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'I hired a car from Pune to Mumbai with Sai Trupti Cabs and had a great experience. The car was clean and the driver was punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Patwardhan',
    feedback: 'Sai Trupti Cabs provided excellent Pune Mumbai car hire service. Smooth journey and very professional driver.',
    rating: 5,
  },
];























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Mumbai Car Hire",
  "image": "https://saitrupticabs.com/assets/images/pune-mumbai-car-hire.jpg",
  "description": "Book Pune Mumbai Car Hire with Sai Trupti Cabs for affordable, comfortable, and reliable travel. Choose from a range of AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. Enjoy 24/7 booking, professional chauffeurs, and transparent pricing for a smooth ride.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15768"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-mumbai-car-hire"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune Mumbai Car Hire | Affordable & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune Mumbai Car Hire with Sai Trupti Cabs for affordable, comfortable, and reliable travel. Choose from a range of AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. Enjoy 24/7 booking, professional chauffeurs, and transparent pricing for a smooth ride." 
  />
  <meta 
    name="keywords" 
    content="Pune Mumbai Car Hire, Pune Mumbai Car Rental, Pune Mumbai Taxi Hire, Pune Mumbai Innova Hire, Pune Mumbai Ertiga Hire, Pune Mumbai Sedan Hire, Pune Mumbai AC Car Hire, Pune Mumbai Luxury Car Hire, Pune Mumbai Chauffeur Service, Affordable Pune Mumbai Car Rental, Pune Mumbai Outstation Hire, Pune Mumbai Airport Transfer Hire, Pune Mumbai Car Booking Online, Pune Mumbai Vehicle Hire, Pune Mumbai Taxi near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punemumbaicarhire;